var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuizWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 13.9998C0.666504 6.63984 6.63984 0.666504 13.9998 0.666504C21.3598 0.666504 27.3332 6.63984 27.3332 13.9998C27.3332 21.3598 21.3598 27.3332 13.9998 27.3332C6.63984 27.3332 0.666504 21.3598 0.666504 13.9998ZM15.3332 19.3332V21.9999H12.6665V19.3332H15.3332ZM13.9998 24.6666C8.11981 24.6666 3.33315 19.8799 3.33315 13.9999C3.33315 8.11989 8.11981 3.33322 13.9998 3.33322C19.8798 3.33322 24.6665 8.11989 24.6665 13.9999C24.6665 19.8799 19.8798 24.6666 13.9998 24.6666ZM8.6665 11.3331C8.6665 8.38646 11.0532 5.99979 13.9998 5.99979C16.9465 5.99979 19.3332 8.38646 19.3332 11.3331C19.3332 13.0437 18.2798 13.9642 17.2542 14.8605C16.2812 15.7108 15.3332 16.5393 15.3332 17.9998H12.6665C12.6665 15.5714 13.9227 14.6086 15.0271 13.762C15.8935 13.0979 16.6665 12.5054 16.6665 11.3331C16.6665 9.86646 15.4665 8.66646 13.9998 8.66646C12.5332 8.66646 11.3332 9.86646 11.3332 11.3331H8.6665Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizWhite);
export default ForwardRef;